import { useState, useCallback } from 'react'

/**
 * Custom hook to get user's geolocation coordinates
 * @returns {Object} { coordinates, loading, error, getLocation }
 */
export const useGeolocation = () => {
  const [coordinates, setCoordinates] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const getLocation = useCallback(() => {
    setLoading(true)
    setError(null)

    if (!navigator.geolocation) {
      setError('Geolocation is not supported by your browser')
      setLoading(false)
      return
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        setCoordinates({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        })
        setLoading(false)
      },
      (err) => {
        let errorMessage = 'Unable to retrieve your location'

        switch (err.code) {
          case err.PERMISSION_DENIED:
            errorMessage = 'Permission denied. Please enable location access.'
            break
          case err.POSITION_UNAVAILABLE:
            errorMessage = 'Location information is unavailable.'
            break
          case err.TIMEOUT:
            errorMessage = 'Location request timed out.'
            break
          default:
            errorMessage = 'An unknown error occurred.'
        }

        setError(errorMessage)
        setLoading(false)
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      },
    )
  }, [])

  return {
    coordinates,
    loading,
    error,
    getLocation,
  }
}
